import { PreviewChip } from "../card-types";

export const defaultSubtitle =
  "See data across all channels and systems, including call centers, ticketing systems, payment processors, and more.";

export const defaultPreviewChips: PreviewChip[] = [
  { icon: "/assets/IconsLibrary/active-subscribers-icon.svg", label: "Active Subscribers" },
  { icon: "/assets/IconsLibrary/mrr-icon.svg", label: "MRR" },
  { icon: "/assets/IconsLibrary/churn-dash-icon.svg", label: "Voluntary Churn", dash: true },
  { icon: "/assets/IconsLibrary/churn-dash-icon.svg", label: "Involuntary Churn", dash: true },
  { icon: "/assets/IconsLibrary/reactivations-icon.svg", label: "Reactivations" },
  { icon: "/assets/IconsLibrary/failed-payment-icon.svg", label: "Failed Payment" },
  { icon: "/assets/IconsLibrary/call-center-icon.svg", label: "Call Center Audit" },
];
